import React from 'react';
import Services from '../Components/Services';
import { engineeringConsultancy, digitalServices, dedicatedResourcesServices } from './../Data/services';
import Breadcrumb from '../Components/Breadcrumb';

function ServicesPage() {
    const breadcrumbLinks = [
        { label: 'Home', url: '/' },
        { label: 'Services' },
    ];

    // Example: Merge all services if needed
    const allServices = [...engineeringConsultancy, ...digitalServices, ...dedicatedResourcesServices];

    return (
        <>
            <Breadcrumb pageTitle="Services" breadcrumbLinks={breadcrumbLinks} />
            
            <Services services={allServices} />
        </>
    );
}

export default ServicesPage;
